<template>
  <div class="max-w-screen-md w-full mx-auto py-6 bg-white p-4 shadow">
    <slot />
  </div>
</template>
